import { Inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { UnespCoreEnvironment } from '@unesp/core'
import { identity, map, Observable, startWith, takeLast } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'
import { Perfil, PerfisDoUsuario } from '../models/perfil'

@Injectable({
  providedIn: 'root',
})
export class PerfilService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  listarPerfil(): Observable<any> {
    return this.http.get<Perfil>(`${this.baseUrl}/perfil`).pipe(identity, this.errorHandlerService.catchError())
  }

  listaUsuariosDoPerfil(id: number): Observable<Perfil[]> {
    return this.http
      .get<Perfil[]>(`${this.baseUrl}/perfil/${id}/usuario`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  listaPerfisDoUsuario(identificacao: string): Observable<PerfisDoUsuario[]> {
    return this.http
      .get<PerfisDoUsuario[]>(`${this.baseUrl}/perfil/${identificacao}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  excluir(idPerfil: number, idUser: number): Observable<Perfil> {
    return this.http
      .delete<Perfil>(`${this.baseUrl}/perfil/${idPerfil}/usuario/${idUser}`)
      .pipe(identity, this.errorHandlerService.catchError())
  }

  adicionarUsuario(idPerfil: number, identificacao: string) {
    identificacao = identificacao.replace('@unesp.br', '')
    return this.http.post<any>(`${this.baseUrl}/perfil/${idPerfil}/usuario/${identificacao}`, undefined).pipe(
      identity,
      this.errorHandlerService.catchError(),
      map(() => {
        return true
      }),
      startWith(false),
      takeLast(1)
    )
  }
}
